import { CustomerReturnSummaryZodSchema } from "@redotech/redo-return-core-common/return";
import * as z from "zod";

/** The customer's other orders and returns, shown in the return page's customer history panel. */
export const getReturnCustomerHistory = {
  name: "getReturnCustomerHistory" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({
    customerOrders: z.array(z.any()),
    customerReturns: z.array(CustomerReturnSummaryZodSchema),
  }),
};
